import { Section } from 'shared/components/Section';
import { HouseSubscriptionBannerContainer, SaveSearchModalContainerLoadable } from './containers';
import { useEventCallback } from '@cian/react-utils';
import { useSaveSearchMicrofrontend, useSearchParams } from './hooks';
import { useCallback, useState } from 'react';

export const HouseSubscriptionContainer = () => {
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const { manifest, microfrontendRef, isLoading, isError, prepareSaveSearchMicrofrontend, openSaveSearchModal } =
    useSaveSearchMicrofrontend();

  const handleOpen = useCallback(async () => {
    setSearchModalOpen(true);

    /** При первой загрузке модалки манифест еще не загружен, ждем полной подготовки микрофронта */
    if (!manifest) {
      await prepareSaveSearchMicrofrontend();
    }

    openSaveSearchModal();
  }, [manifest, openSaveSearchModal, prepareSaveSearchMicrofrontend]);

  const handleClose = useEventCallback(() => {
    setSearchModalOpen(false);
  });

  const parameters = useSearchParams();

  return (
    <Section>
      <HouseSubscriptionBannerContainer onClick={handleOpen} />
      {searchModalOpen && (
        <SaveSearchModalContainerLoadable
          manifest={manifest}
          microfrontendRef={microfrontendRef}
          parameters={parameters}
          loading={isLoading}
          error={isError}
          onClose={handleClose}
          onRetryAfterError={handleOpen}
        />
      )}
    </Section>
  );
};
